import * as actionCreatorFactory from "typescript-fsa";
import { Action, isType } from "typescript-fsa";

import * as auth from "@auth/actions";
import * as reports from "@reports/actions";
import { isHttpStateErrorUnauthenticated } from "@orm/models";

import { ApiRequest } from "../requests";
import {
    ApiRequestProgress,
    ApiRequestResponse,
    ApiRequestErrorPair,
} from "../models/actions";
import {
    API_REQUEST,
    API_REQUEST_PROGRESS,
    API_REQUEST_EXPIRE,
    API_RESPONSE_SUCCESS,
    API_RESPONSE_FAILURE,
} from "../constants";

const actionCreator = actionCreatorFactory.default();

const apiRequest = actionCreator<ApiRequest>(API_REQUEST);
const apiRequestProgress = actionCreator<ApiRequestProgress>(API_REQUEST_PROGRESS);
const apiRequestExpire = actionCreator<ApiRequest>(API_REQUEST_EXPIRE);
const apiResponseSuccess = actionCreator<ApiRequestResponse>(API_RESPONSE_SUCCESS);
const apiResponseFailure = actionCreator<ApiRequestErrorPair>(API_RESPONSE_FAILURE);

type ApiAction = auth.AuthAction | reports.ReportsAction | Action<ApiRequest> |
    Action<ApiRequestResponse> | Action<ApiRequestErrorPair>;

const isFailedResponseUnauthenticatedNotLogin = (action: ApiAction) =>
    isType(action, apiResponseFailure)
        && isHttpStateErrorUnauthenticated(action.payload.error)
        && (action.payload.request == null || action.payload.request.getEndpoint() !== "login");

export {
    ApiAction,
    apiRequest,
    apiRequestProgress,
    apiRequestExpire,
    apiResponseSuccess,
    apiResponseFailure,
    isFailedResponseUnauthenticatedNotLogin,
};
